import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachTinhThanh: [],
  danhSachTinhThanhTrongVung: [],
  danhSachTinhThanhFree: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
